import { FC, PropsWithChildren } from "react";

import { createComponentStyleHook } from "capitalrx-components-2.0/lib/tokens";
import { Bold } from "capitalrx-components-2.0/lib/typography";
import classNames from "classnames";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownGroupHeadingStyles = createComponentStyleHook<PropsWithChildren<{}>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_group_heading",
});

/**
 * A group heading component.
 */
export const GroupHeading: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownGroupHeadingStyles(props);

  return (
    <StyleModeBoundary mode={mode}>
      <div className={classNames(styles.GroupHeading, "group-heading")}>
        <Bold>{children}</Bold>
      </div>
    </StyleModeBoundary>
  );
};
